import React from "react";

import SupplierListCard from "./SupplierListCard";
import SupplierSkeleton from "./SupplierSkeleton";

const SupplierPanel = ({
  suppliers,
  total,
  radiusKm,
  isResolving,
  isReloading,
  isFetching,
  asSheet,
  open,
  onClose,
  onRefresh,
  onOpenSupplier,
  onHoverSupplier,
  save,
}) => {
  const showSkeleton = isReloading || (isResolving && !suppliers.length);

  const heading = isResolving
    ? "Finding suppliers nearby"
    : `${total} ${total === 1 ? "Supplier" : "Suppliers"} nearby`;

  if (!open) return null;

  return (
    <>
      {asSheet && (
        <button
          type="button"
          className="home-sheet-backdrop"
          aria-label="Close supplier list"
          onClick={onClose}
        />
      )}

      <aside
        id="home-supplier-panel"
        className={`home-panel${asSheet ? " home-panel-sheet" : ""}`}
        aria-label="Suppliers nearby"
      >
        {asSheet && (
          <button
            type="button"
            className="home-panel-handle"
            onClick={onClose}
            aria-label="Close supplier list"
          />
        )}

        <header className="home-panel-header-card">
          <div className="home-panel-heading">
            <h2 className="home-panel-title" aria-live="polite">
              {heading}
            </h2>
            <p className="home-panel-subtitle">
              Within {radiusKm} km · sorted by distance
            </p>
          </div>

          <div className="home-panel-actions">
            <button
              type="button"
              className={`home-panel-refresh${isFetching ? " is-busy" : ""}`}
              onClick={onRefresh}
              disabled={isFetching}
              aria-label="Refresh suppliers"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
              </svg>
            </button>

            <button
              type="button"
              className="home-panel-close"
              onClick={onClose}
              aria-label="Hide supplier list"
            >
              <img
                src="/assets/icons/panel-close.svg"
                width="24"
                height="24"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>
        </header>

        {showSkeleton ? (
          <SupplierSkeleton />
        ) : suppliers.length ? (
          <ul className="home-panel-list">
            {suppliers.map((supplier) => (
              <SupplierListCard
                key={supplier.id}
                supplier={supplier}
                saved={save.isSaved(supplier)}
                pending={save.isPending(supplier)}
                canSave={save.canSave}
                onOpen={onOpenSupplier}
                onToggleSave={save.toggleSaved}
                onHover={onHoverSupplier}
              />
            ))}
          </ul>
        ) : (
          <p className="home-panel-empty">
            No suppliers within {radiusKm}km. Widen the radius or clear your
            filters to see more.
          </p>
        )}
      </aside>
    </>
  );
};

export default React.memo(SupplierPanel);
